import styled from 'styled-components';

import { mediaQuery } from '../../../styles/global';

export const Caption = styled.h1`
  font-family: ${({ theme }) => theme.fontFamily.bold};
  color: ${({ theme }) => theme.colors.white};
  font-size: 4rem;
  margin: 0;
  text-align: center;
  line-height: 100%;
  margin-bottom: 4rem;

  ${mediaQuery.maxWidth.phone} {
    font-size: 2rem;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 75vh;
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  padding: 13.25rem 20px 0;

  ol {
    ${mediaQuery.maxWidth.tablet} {
      padding-left: 20px;
    }
  }
  i {
    color: white;
    font-style: normal;
    font-family: ${({ theme }) => theme.fontFamily.medium};
  }

  ${mediaQuery.maxWidth.phone} {
    min-height: 90vh;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (orientation: landscape) and (max-height: 700px) {
    position: relative;
    bottom: unset;
    left: unset;
    transform: none;
    padding-bottom: 30px;
  }
  text-align: center;
`;

export const TextBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex-grow: 1;
  z-index: 5;
`;

export const Text = styled.div`
  h2,
  h3 {
    color: white;
    font-family: ${({ theme }) => theme.fontFamily.bold};
  }
  h2 {
    font-size: 2em;
  }
  h3 {
    font-size: 1.3em;
  }

  a {
    color: ${({ theme }) => theme.colors.white};
    text-decoration: underline;
    font-family: ${({ theme }) => theme.fontFamily.bold};
  }
  p {
    color: rgba(255, 255, 255, 0.75);
    font-family: ${({ theme }) => theme.fontFamily.regular};
  }
`;
